import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FormDropdown from 'Components/Inputs/FormDropdown';
import { Card } from 'Feature/CommonComponents/ContentComponents';
import { CardType } from 'Feature/CommonComponents/Enums';
import { CardHeader } from 'Components/Card/CardHeader';
import { CardBody } from 'Components/Card/CardBody';
import { FormProvider, useForm } from 'react-hook-form';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import styles from './styles.module.scss';
import ProvincialApplicableRatesForm from './ProvincialApplicableRatesSubmissionForm';
import { getApplicableRates } from './ProvincialApplicablesRates.Service';
import { ProvincialApplicableRatesProps } from 'Feature/Claims/components/ProvincialApplicableRates/types';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { ToastNotification } from 'Feature/CommonComponents/ContentComponents';
import { ApplicationStates } from 'Components/Enums/ApplicationStatus';
import { isUserInRoles } from 'Components/Common/UserHelpers/CheckUserRole';
import { ModuleMapping, UserRole } from '@hobt/constants';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { HbtSitecoreContextType } from 'Foundation/HydrateSitecoreContext';
import { useFeature } from 'flagged';
import { FeatureFlags } from 'Feature/Enums/FeatureFlag.enum';
import i18n from 'i18next';

const ProvincialApplicableRates: React.FC<ProvincialApplicableRatesProps> = (
  props: ProvincialApplicableRatesProps
) => {
  const authenticationContext = useAuthenticationContext();
  const [provence, setProvence] = useState(0);
  const [toastState, setToastState] = useState<ApplicationStates>(ApplicationStates.DEFAULT);
  const [showToast, setShowToast] = useState<boolean>(false);
  const sitecoreContextFactory = useSitecoreContext();
  const sitecoreContext = sitecoreContextFactory?.sitecoreContext as HbtSitecoreContextType;
  const siteTypeIsInternal = useFeature(FeatureFlags.INTERNAL);
  const isMasterUser =
    isUserInRoles(
      ModuleMapping.claim,
      [UserRole.MasterUser],
      sitecoreContext?.user?.moduleRoleMapping
    ) && siteTypeIsInternal === true;

  const isBusinessUser =
    isUserInRoles(
      ModuleMapping.claim,
      [UserRole.BusinessUser],
      sitecoreContext?.user?.moduleRoleMapping
    ) && siteTypeIsInternal === true;

  const [rates, setRates] = useState<any>([]);
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: false,
    defaultValues: {}
  } as Record<string, any>);

  const handelProvence = () => {
    setProvence(methods.getValues('provinceCode'));
  };

  useEffect(() => {
    provence > 0 && getProvinceRatesData(provence);
  }, [provence]);

  const getProvinceRatesData = async (provence: any) => {
    try {
      const res = await getApplicableRates(authenticationContext, provence);
      res.data[0].futureEffectiveDate = null;
      setRates(res.data);
    } catch (e) {
      setShowToast(true);
      setToastState(ApplicationStates.ERROR);
      setRates([]);
    }
  };

  const onToastCloseHandler = () => {
    setShowToast(false);
  };
  const access = isMasterUser || isBusinessUser;
  return (
    <>
      <ToastNotification
        type={toastState}
        isActive={showToast}
        title={
          toastState === ApplicationStates.ERROR
            ? i18n.t('DefaultActions-SystemErrorToast-Action-Title')
            : i18n.t('DefaultActions-SystemSuccessToast-Action-Title')
        }
        content={{
          value: i18n.t('DefaultsInventoryTable-SystemErrorToast-Message')
        }}
        onCloseCallback={() => onToastCloseHandler()}
      />
      <fieldset disabled={!access}>
        <Card type={CardType.HORIZONTAL_BLUE}>
          <CardHeader separator>
            <div className="row">
              <div className="col-6">
                <h2 className="card-title">
                  <Text field={{ value: props?.fields?.provinceAppliableRatesTitle?.value }} />
                </h2>
              </div>
              <div className="col-2"></div>
              <div className="col-4">
                <h2 className="card-title rightAlign">
                  <Link to="/provincial-rates-table">
                    {props?.fields?.provinceApplicableTableLink?.value}
                  </Link>
                </h2>
              </div>
            </div>
          </CardHeader>
          <FormProvider {...methods}>
            <form id="addUserForm" className="form add-user-form" noValidate>
              <CardBody>
                <div className="row card__body-row">
                  <div className="form__element form__element--2-column col-1 mt-3">
                    <b>
                      {' '}
                      <Text field={props.fields.provinceLabel} />
                    </b>
                  </div>
                  <div className="col-11">
                    <FormDropdown
                      name="provinceCode"
                      className={styles.adjustedWidth}
                      label={''}
                      options={props?.fields?.province?.fields?.listItems}
                      setAsNumber={false}
                      isDisabled={false}
                      handleChange={handelProvence}
                    />
                  </div>
                </div>
              </CardBody>
            </form>
          </FormProvider>
          {rates[0] ? (
            <ProvincialApplicableRatesForm
              fields={props.fields.applicableratesform.fields}
              rates={rates[0]}
            />
          ) : (
            <></>
          )}
        </Card>
      </fieldset>
    </>
  );
};

export default ProvincialApplicableRates;
